import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {CLStore} from 'common/src/redux/store';
import {CampaignSetupAgentToolName} from '../../campaignSetupAgent.enums';
import {contentCardSchema} from '../../schemas/contentCardSchema';
import addOrUpdateCardTool from '../general/addOrUpdateCardTool/addOrUpdateCardTool';
import getContentFeedColumnsTool from './getContentFeedColumnsTool';
import getContentFeedsTool from './getContentFeedsTool';
import getContentSignalsTool from './getContentSignalsTool';
import getContentSetsTool from './getContentSetsTool';
import matchStrategyTool from '../strategy/matchStrategyTool';

export default function addOrUpdateContentCardTool(store: CLStore) {
  return addOrUpdateCardTool({
    store,
    cardType: NodeType.CONTENT_FEED,
    cardSchema: contentCardSchema,
    description: 'Add or update SINGLE Content card. Can search for content feeds and content sets by prompt.',
    tools: [
      getContentFeedsTool(),
      getContentSignalsTool(store),
      getContentFeedColumnsTool(),
      getContentSetsTool(),
      matchStrategyTool(store),
    ],
    cardSpecificInstructions: `1. If a content feed ID is provided, use it directly. If a content set ID is provided, use it directly. Only use the ${CampaignSetupAgentToolName.GetContentFeeds} or ${CampaignSetupAgentToolName.GetContentSets} tools if no ID is provided or if the user provided other search details.
2. If setting the content set in the card, you must set the feed ID of the card to the feed ID of the content set.
3. Use the ${CampaignSetupAgentToolName.GetContentSignals} tool to find the best matching signals for the content feed card.
4. Use the ${CampaignSetupAgentToolName.GetContentFeedColumns} tool to find the best matching columns for the content feed card.
5. Use the ${CampaignSetupAgentToolName.MatchStrategy} tool to find the best matching strategy following user's request.`,
  });
}
